import React, { useState } from 'react';
import './Navigation.css';

interface NavigationProps {
  currentPage: string;
  onNavigate: (page: string) => void;
}

export function Navigation({ currentPage, onNavigate }: NavigationProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleNavigate = (page: string) => {
    onNavigate(page);
    setIsMenuOpen(false);
  };

  return (
    <>
      {isMenuOpen && (
        <div 
          className="menu-overlay" 
          onClick={() => setIsMenuOpen(false)}
        />
      )}
      <nav className="navigation">
        <div className="nav-container">
          <div className="nav-logo">
            <span className="logo-text">SFRays</span>
          </div>
          
          <button 
            className="menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger ${isMenuOpen ? 'open' : ''}`}></span>
          </button>

          <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <button
              className={`nav-link ${currentPage === 'home' ? 'active' : ''}`}
              onClick={() => handleNavigate('home')}
            >
              Home
            </button>
            <button
              className={`nav-link ${currentPage === 'training' ? 'active' : ''}`}
              onClick={() => handleNavigate('training')}
            >
              Training
            </button>
            <button
              className={`nav-link ${currentPage === 'services' ? 'active' : ''}`}
              onClick={() => handleNavigate('services')}
            >
              Services
            </button>
            <button
              className={`nav-link ${currentPage === 'contact' ? 'active' : ''}`}
              onClick={() => handleNavigate('contact')}
            >
              Contact
            </button>
          </div>
        </div>
      </nav>
    </>
  );
}